import styled from "styled-components";

export const PanicButtonTooltipCloseBox = styled.div`
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
    width: 1rem;
    height: 1rem;
    cursor: pointer;
      
    &::before, &::after {
        position: absolute;
        content: ' ';
        height: 1rem;
        width: 0.1rem;
        background-color: black;
    }
    &::before {
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
`;